import axios from 'axios';
import Cookies from 'js-cookie';
import { auth } from 'config/firebase';

const instance = axios.create({
    baseURL: process.env.SERVER_BASE_URL, 
    withCredentials: true, 
    headers: {
        'Content-Type': 'application/json',
        'X-CSRFToken': Cookies.get('csrftoken')
    },
});

instance.interceptors.request.use(async config => {
    config.headers.Authorization = auth.currentUser
        ? await auth.currentUser.getIdToken()
        : null;

    return config;
}, error => {
    return Promise.reject(error);
});

export default instance;